import React, { useState } from 'react';
import {
    Typography,
    Box,
    Avatar,
    Paper,
} from '@mui/material';
import { Button } from 'react-bootstrap';
import { color } from 'highcharts';


const getInitials = (name) => {
    const words = name.split(' ');
    return words.length > 1
        ? words[0][0].toUpperCase() + words[1][0].toUpperCase()
        : name.slice(0, 2).toUpperCase();
};


const MemberProjectProfile = ({ open, onClose }) => {

    // Dummy user and project details (can be passed via props)
    const user = {
        name: 'Salona Mishra',
        image: '/assets/images/users/user1.png',
    };

    const project = {
        name: 'Project Quantum',
        image: '',
        description: 'Worked Desk 1',
    };

    return (
        <>
            <Paper sx={{ p: 2, border: '1px solid #0076FE', boxShadow: 'none' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                    <Box>
                        <Typography fontWeight="400" sx={{ fontSize: '12px', color: '#606060', fontFamily: 'Manrope' }}>Member</Typography>
                        <Box display="flex" alignItems="center" gap={1} mt={1}>
                            <Avatar src={user.image} sx={{ fontSize: '14px', background: '#0067C7', fontFamily: 'Manrope' }}>
                                {!user.image && getInitials(user.name)}
                            </Avatar>
                            <Box>
                                <Typography fontWeight="bold" sx={{ fontSize: '14px', color: '#373737', fontFamily: 'Manrope' }}>{user.name}</Typography>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#8C8C8C', fontFamily: 'Manrope' }}>
                                    Project Manager
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                    <Box>
                        <Typography fontWeight="400" sx={{ fontSize: '12px', color: '#606060', fontFamily: 'Manrope' }}>Project</Typography>
                        <Box display="flex" alignItems="center" gap={1} mt={1}>
                            <Avatar src={project.image} sx={{ fontSize: '14px', background: '#0067C7', fontFamily: 'Manrope' }}>
                                {!project.image && getInitials(project.name)}
                            </Avatar>
                            <Box>
                                <Typography fontWeight='bold' sx={{ fontSize: '14px', color: '#373737', fontFamily: 'Manrope' }}>{project.name}</Typography>
                                <Typography variant="body2" sx={{ fontSize: '12px', color: '#8C8C8C', fontFamily: 'Manrope' }}>{project.description}</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box mt={2} display="flex" alignItems='center' justifyContent="space-between">
                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#373737', fontWeight: '600', fontFamily: 'Manrope' }}>
                        <span className="d-block fw-normal" style={{ fontSize: '12px', color: '#8C8C8C', fontFamily: 'Manrope' }}>Time Span</span> Tue, Mar 25, 2025from10:35:26 amto2:50 pm
                    </Typography>
                    {/* <Button variant="contained" style={{ backgroundColor: '#27AE60', color: '#FFFFFF', p: '4px 25px', fontSize: '16px', fontWeight: '500', height: '30px', width: '80px', lineHeight: '1px' }}>
                        Add
                    </Button> */}
                </Box>

            </Paper>
        </>


    );
};

export default MemberProjectProfile;
